module.exports = __webpack_public_path__ + "img/ic_car.827bc97b.svg";